// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReleaseGoNoGoThreshold,
  ReleaseGoNoGoThresholdFromJSON,
  ReleaseGoNoGoThresholdToJSON,
  RequirementMinified,
  RequirementMinifiedFromJSON,
  RequirementMinifiedToJSON,
  TestPlanMinified,
  TestPlanMinifiedFromJSON,
  TestPlanMinifiedToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface Release
 */
export interface Release {
  /**
   *
   * @type {number}
   * @memberof Release
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  description?: string;
  /**
   * Optional glob pattern matched against build versions to auto-group builds into this release (TCV-6723). A leading `v` is ignored and `*` matches any suffix — e.g. `2.14.*` attaches v2.14.0, 2.14.1 and 2.14.0-rc2 but not 2.15.0.
   * @type {string}
   * @memberof Release
   */
  versionPattern?: string;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  status: ReleaseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  targetDate?: string;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  releaseDate?: string;
  /**
   *
   * @type {ReleaseGoNoGoThreshold}
   * @memberof Release
   */
  goNoGoThreshold?: ReleaseGoNoGoThreshold;
  /**
   *
   * @type {boolean}
   * @memberof Release
   */
  isPublic?: boolean;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  publicToken?: string;
  /**
   *
   * @type {Array<TestPlanMinified>}
   * @memberof Release
   */
  testPlans?: Array<TestPlanMinified>;
  /**
   * Requirements associated with this release
   * @type {Array<RequirementMinified>}
   * @memberof Release
   */
  requirements?: Array<RequirementMinified>;
  /**
   *
   * @type {number}
   * @memberof Release
   */
  project: number;
  /**
   *
   * @type {UserMinified}
   * @memberof Release
   */
  createdBy: UserMinified;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof Release
   */
  updatedAt: string;
}

export function ReleaseFromJSON(json: any): Release {
  return {
    id: json["id"],
    name: json["name"],
    description: !exists(json, "description") ? undefined : json["description"],
    versionPattern: !exists(json, "version_pattern")
      ? undefined
      : json["version_pattern"],
    status: json["status"],
    targetDate: !exists(json, "target_date") ? undefined : json["target_date"],
    releaseDate: !exists(json, "release_date")
      ? undefined
      : json["release_date"],
    goNoGoThreshold: !exists(json, "go_no_go_threshold")
      ? undefined
      : ReleaseGoNoGoThresholdFromJSON(json["go_no_go_threshold"]),
    isPublic: !exists(json, "is_public") ? undefined : json["is_public"],
    publicToken: !exists(json, "public_token")
      ? undefined
      : json["public_token"],
    testPlans: !exists(json, "test_plans")
      ? undefined
      : (json["test_plans"] as Array<any>).map(TestPlanMinifiedFromJSON),
    requirements: !exists(json, "requirements")
      ? undefined
      : (json["requirements"] as Array<any>).map(RequirementMinifiedFromJSON),
    project: json["project"],
    createdBy: UserMinifiedFromJSON(json["created_by"]),
    createdAt: json["created_at"],
    updatedAt: json["updated_at"],
  };
}

export function ReleaseToJSON(value?: Release): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    name: value.name,
    description: value.description,
    version_pattern: value.versionPattern,
    status: value.status,
    target_date: value.targetDate,
    release_date: value.releaseDate,
    go_no_go_threshold: ReleaseGoNoGoThresholdToJSON(value.goNoGoThreshold),
    is_public: value.isPublic,
    public_token: value.publicToken,
    test_plans:
      value.testPlans === undefined
        ? undefined
        : (value.testPlans as Array<any>).map(TestPlanMinifiedToJSON),
    requirements:
      value.requirements === undefined
        ? undefined
        : (value.requirements as Array<any>).map(RequirementMinifiedToJSON),
    project: value.project,
    created_by: UserMinifiedToJSON(value.createdBy),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReleaseStatusEnum {
  Planned = "planned",
  InProgress = "in_progress",
  Ready = "ready",
  Shipped = "shipped",
  Blocked = "blocked",
}
